import {BaseService} from "./base.service";

class QuotersService extends BaseService {

    constructor() {
        super('api/quoters')
    }

    findQuotes(params) {
        return this.http.get(`api/find-quotes`, {params}).then(response => response.data).catch(err => err.message);
    }

    printQuote(id) {
        return this.http.post(`api/print-quoter/${id}`).then(response => response.data).catch(err => err.message);
    }

    renewOne(params) {
        return this.http.post(`api/renew-one`, {params}).then(response => response.data).catch(err => err.message);
    }

}

export const quotersService = new QuotersService();
